// extracted by mini-css-extract-plugin
export default {"socials_link":"linkIcon_socials_link__dpEHh"};